'use client'

import { useContext, useEffect, useRef, useState } from "react"
// import { CommonListContext } from "../_config"
import { CommonListContext } from "@/util/board_config"
import { usePathname, useRouter } from "next/navigation";
import { replaceHistory } from "@/type/historyStack";
import ListV2 from "@/components/board/list_v2"
import { NavContext } from "@/context/navContext";
import { useLocale } from "next-intl";
import { DeviceContext } from "@/context/deviceContext";

import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import SlideText from "@/components/etc/SlideText";
import LocaleFormat from "@/components/etc/localeFormat";

export default function SportsAnalysis() {
    const { list, setContent, loading, setIsFirstRender } = useContext(CommonListContext)
    const locale = useLocale();
    const router = useRouter()
    const pathname = usePathname()
    const { movePage } = useContext(NavContext)


    function setContentfunc(id: number) {
        // router.push(`/sportsanalysis/?id=${id}`)
        // movePage(`/sportsanalysis/?id=${id}`)
        setContent(id)
    }
    useEffect(() => {
        replaceHistory("/sportsanalysis/");
    }, [pathname])

    return (

        <ListV2 list={list}
            setContent={setContentfunc}
            className={`sports-analysis-list-new`}
            setIsFirstRender={setIsFirstRender}
            loading={loading}>
            {(list: any, idx: number) => (
                <>
                    <div className={`date`}>
                        <LocaleFormat date={list.game_time} format="MMM DD (ddd) HH:mm" />
                    </div>

                    <div className={`home box`}>
                        <div className={`img`}>
                            {
                                list.home_team_logo
                                    ? <img className="team-amb"
                                        src={list.home_team_logo}
                                        alt=""
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = `${require('@/public/image/etc/LogoA.png').default.src}`;
                                        }} />
                                    : <img className="team-amb" src={require(`@/public/image/etc/LogoA.png`).default.src} alt="" />
                            }
                        </div>
                        <div className={`text`}>
                            <div>
                                {(() => {
                                    const homeTeam = list.home_team || '';
                                    const len = Array.from(homeTeam).length;
                                    const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.2)));
                                    return <div className={`ellipsis`} style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                })()}
                                {/* {list.home_team} */}
                            </div>
                            <div>{list.home_info}</div>
                        </div>
                    </div>

                    <div className={`vs`}>VS</div>

                    <div className={`away box`}>
                        <div className={`img`}>
                            {
                                list.away_team_logo
                                    ? <img className="team-amb"
                                        src={list.away_team_logo}
                                        alt=""
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = `${require('@/public/image/etc/LogoB.png').default.src}`;
                                        }} />
                                    : <img className="team-amb" src={require(`@/public/image/etc/LogoB.png`).default.src} alt="" />
                            }
                        </div>
                        <div className={`text`}>
                            <div>
                                {(() => {
                                    const homeTeam = list.away_team || '';
                                    const len = Array.from(homeTeam).length;
                                    const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.2)));
                                    return <div style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                })()}
                                {/* {list.away_team} */}
                            </div>
                            <div>{list.away_info}</div>
                        </div>
                    </div>
                    {(() => {
                        const league = list.league_name || '';
                        const len = Array.from(league).length;
                        const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.4)));
                        return (
                            <ETC league={league} fontSize={fontSize} />
                        )
                    })()}
                    {/* <div className={`etc`}>{list.league_name}</div> */}
                </>
            )}
        </ListV2>
    )
}

function ETC({ league, fontSize }: { league: string, fontSize: number }) {
    // const etcRef = useRef<HTMLDivElement>(null)
    const [contentEl, setContentEl] = useState<HTMLDivElement | null>(null)
    return (
        <div className="etc" style={{ fontSize: `${fontSize}px` }} ref={setContentEl}>
            {/* <div ref={leagueRef} className={animation ? "longContents" : ""}>{league}</div> */}
            <SlideText coverEl={contentEl} fontSize={14} text={league} />
        </div>
    )
}
